import { Routes } from '@angular/router';
import { MsalGuard } from '@groundworks/ngx-groundworks-auth';
import { CalendarShellComponent } from './calendar/calendar-shell.component';
import { OpportunityShellComponent } from './opportunities/opportunity-shell.component';
import { ServiceCalendarGuard } from './calendar/guards/service-calendar.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/opportunity',
    pathMatch: 'full',
  },
  {
    path: 'opportunity',
    canActivate: [MsalGuard],
    component: OpportunityShellComponent,
    loadChildren: () => import('./opportunities/features/opportunity/opportunity.routing')
      .then(m => m.OPPORTUNITY_ROUTES)
  },
  {
    path: 'calendar',
    canActivate: [MsalGuard],
    component: CalendarShellComponent,
    loadChildren: () =>
      import('./calendar/features/routing/calendar.routing').then(
        (m) => m.SALES_CALENDAR_ROUTES
      ),
  },
  {
    path: 'service-calendar',
    canActivate: [MsalGuard, ServiceCalendarGuard],
    component: CalendarShellComponent,
    loadChildren: () =>
      import('./calendar/features/routing/calendar.routing').then(
        (m) => m.SERVICE_CALENDAR_ROUTES
      ),
  },
];
